import { Modal, Button } from "react-bootstrap";

const DeleteModal = ({ show, onClose, onConfirm, size }) => {
  return (
    <Modal show={show} onHide={onClose} centered  size={size}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Delete</Modal.Title>
      </Modal.Header>

      <Modal.Body>Are you sure you want to delete this user?</Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteModal;
